import styled from 'styled-components';
import FormImg from '~/assets/images/form.svg';
import HomeImg from '~/assets/icons/home_white.svg';

export interface LogoutStyledProps {
  show: boolean;
}

export interface LogoStyledProps {
  pointer: boolean;
  logo: string;
}

export interface InputStyledProps {
  isRtl?: boolean;
}

export const LoginFormStyled = styled.div`
  position: relative;
  width: 46.428rem;
  height: 61.428rem;
  margin: 0 auto 0 20rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 70px 0 70px;

  &:before {
    content: '';
    position: absolute;
    top: -1.571rem;
    right: -2.857rem;
    width: 68.928rem;
    height: 65rem;
    background: url(${FormImg}) 0% 0% no-repeat padding-box;
  }
`;

export const LogoStyled = styled.div<LogoStyledProps>`
  width: 10rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};

  background-image: url(${({ logo }) => logo});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export const LogoText = styled.div<{ pointer: boolean }>`
  width: 100%;
  min-height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};
  font:
    normal normal bold 42px/50px Roboto,
    Heebo;
  color: #2a6fdb;
  letter-spacing: 0px;

  html[dir='rtl'] & {
    font-family: Heebo;
  }
`;

export const Logout = styled.div<LogoutStyledProps>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  width: 40px;
  height: 40px;

  position: absolute;
  bottom: 45px;
  right: 45px;

  cursor: pointer;

  background-color: #2a6fdb;
  mask-image: url(${HomeImg});
  background-position: center;
  mask-size: cover;
`;

export const XiomaLogo = styled.img`
  width: 6.43rem;
  height: 5.714rem;
  position: absolute;
  bottom: 2.14rem;
  left: 1.428rem;
`;

export const TitleStyled = styled.h2`
  margin: 20px 0 30px 0;
  text-align: center;
  font:
    normal normal bold 30px/37px Roboto,
    Heebo;
  letter-spacing: 0px;
  color: #2a6fdb;

  html[dir='rtl'] & {
    font-family: Heebo;
  }
`;

export const InputsWrapper = styled.div<InputStyledProps>`
  width: 100%;
  margin-bottom: 20px;

  text-align: ${({ isRtl }) => (isRtl ? 'right' : 'left')};
  text-family: ${({ isRtl }) => (isRtl ? 'Heebo' : 'Roboto')};

  html[dir='rtl'] & {
    text-align: right;
  }

  button {
    display: block;
    margin: 20px auto 0;
  }
`;
